//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ICustomerClient {
  /**
   * @return OK
   */
  getAllCustomersForTenant(): Observable<SwaggerResponse<CustomerDto[]>>;
  /**
   * @return Created
   */
  createCustomer(body: CreateCustomerRequestDto): Observable<SwaggerResponse<string>>;
  /**
   * @return OK
   */
  updateCustomer(body: UpdateCustomerRequestDto): Observable<SwaggerResponse<void>>;
  /**
   * @param customerId (optional)
   * @return OK
   */
  deleteCustomer(customerId: string | undefined): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  getCustomerById(customerId: string): Observable<SwaggerResponse<CustomerDto>>;
  /**
   * @return Created
   */
  addDocumentToCustomer(customerId: string, body: DocumentDto): Observable<SwaggerResponse<IdResponse>>;
  /**
   * @return OK
   */
  getAllCustomerNames(): Observable<SwaggerResponse<CustomerNameDto[]>>;
}

@Injectable({
  providedIn: 'root'
})
export class CustomerClient implements ICustomerClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  getAllCustomersForTenant(): Observable<SwaggerResponse<CustomerDto[]>> {
    let url_ = this.baseUrl + "/api/Customer";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllCustomersForTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllCustomersForTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerDto[]>>;
    }));
  }

  protected processGetAllCustomersForTenant(response: HttpResponseBase): Observable<SwaggerResponse<CustomerDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(CustomerDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<CustomerDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  createCustomer(body: CreateCustomerRequestDto): Observable<SwaggerResponse<string>> {
    let url_ = this.baseUrl + "/api/Customer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
    }));
  }

  protected processCreateCustomer(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : null as any;

        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  updateCustomer(body: UpdateCustomerRequestDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Customer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUpdateCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processUpdateCustomer(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @param customerId (optional)
   * @return OK
   */
  deleteCustomer(customerId: string | undefined): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Customer?";
    if (customerId === null)
      throw new globalThis.Error("The parameter 'customerId' cannot be null.");
    else if (customerId !== undefined)
      url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeleteCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processDeleteCustomer(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getCustomerById(customerId: string): Observable<SwaggerResponse<CustomerDto>> {
    let url_ = this.baseUrl + "/api/Customer/{customerId}";
    if (customerId === undefined || customerId === null)
      throw new globalThis.Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetCustomerById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCustomerById(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerDto>>;
    }));
  }

  protected processGetCustomerById(response: HttpResponseBase): Observable<SwaggerResponse<CustomerDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<CustomerDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  addDocumentToCustomer(customerId: string, body: DocumentDto): Observable<SwaggerResponse<IdResponse>> {
    let url_ = this.baseUrl + "/api/Customer/{customerId}/document";
    if (customerId === undefined || customerId === null)
      throw new globalThis.Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddDocumentToCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddDocumentToCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<IdResponse>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<IdResponse>>;
    }));
  }

  protected processAddDocumentToCustomer(response: HttpResponseBase): Observable<SwaggerResponse<IdResponse>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = IdResponse.fromJS(resultData201);
        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<IdResponse>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getAllCustomerNames(): Observable<SwaggerResponse<CustomerNameDto[]>> {
    let url_ = this.baseUrl + "/api/Customer/names";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllCustomerNames(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllCustomerNames(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerNameDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerNameDto[]>>;
    }));
  }

  protected processGetAllCustomerNames(response: HttpResponseBase): Observable<SwaggerResponse<CustomerNameDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(CustomerNameDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<CustomerNameDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface IDocumentClient {
  /**
   * @return OK
   */
  addAnnotationToImage(documentId: string, body: ImageAnnotation): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  getDocumentsForPet(petId: string): Observable<SwaggerResponse<DocumentDto[]>>;
  /**
   * @return OK
   */
  getDocumentsForCustomer(customerId: string): Observable<SwaggerResponse<DocumentDto[]>>;
  /**
   * @return OK
   */
  getDocumentShortInfosForPet(petId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
  /**
   * @return OK
   */
  getDocumentShortInfosForCustomer(customerId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
  /**
   * @return OK
   */
  getDocumentShortInfosForTreatment(treatmentId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
  /**
   * @return OK
   */
  getPinnedDocumentShortInfosForPet(petId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
  /**
   * @return OK
   */
  getPinnedDocumentShortInfosForCustomer(customerId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
  /**
   * @return OK
   */
  getDocumentShortInfosById(documentId: string): Observable<SwaggerResponse<DocumentShortInfoDto>>;
  /**
   * @return OK
   */
  getDocumentById(documentId: string): Observable<SwaggerResponse<DocumentDto>>;
  /**
   * @return OK
   */
  deleteDocument(documentId: string): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  unpinDocument(documentId: string): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  pinDocument(documentId: string): Observable<SwaggerResponse<void>>;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentClient implements IDocumentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  addAnnotationToImage(documentId: string, body: ImageAnnotation): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Document/{documentId}/addAnnotation";
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddAnnotationToImage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddAnnotationToImage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processAddAnnotationToImage(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getDocumentsForPet(petId: string): Observable<SwaggerResponse<DocumentDto[]>> {
    let url_ = this.baseUrl + "/api/Document/pet/{petId}";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetDocumentsForPet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDocumentsForPet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentDto[]>>;
    }));
  }

  protected processGetDocumentsForPet(response: HttpResponseBase): Observable<SwaggerResponse<DocumentDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DocumentDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getDocumentsForCustomer(customerId: string): Observable<SwaggerResponse<DocumentDto[]>> {
    let url_ = this.baseUrl + "/api/Document/customer/{customerId}";
    if (customerId === undefined || customerId === null)
      throw new globalThis.Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetDocumentsForCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDocumentsForCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentDto[]>>;
    }));
  }

  protected processGetDocumentsForCustomer(response: HttpResponseBase): Observable<SwaggerResponse<DocumentDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DocumentDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getDocumentShortInfosForPet(petId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    let url_ = this.baseUrl + "/api/Document/short/pet/{petId}";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetDocumentShortInfosForPet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDocumentShortInfosForPet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
    }));
  }

  protected processGetDocumentShortInfosForPet(response: HttpResponseBase): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DocumentShortInfoDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentShortInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getDocumentShortInfosForCustomer(customerId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    let url_ = this.baseUrl + "/api/Document/short/customer/{customerId}";
    if (customerId === undefined || customerId === null)
      throw new globalThis.Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetDocumentShortInfosForCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDocumentShortInfosForCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
    }));
  }

  protected processGetDocumentShortInfosForCustomer(response: HttpResponseBase): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DocumentShortInfoDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentShortInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getDocumentShortInfosForTreatment(treatmentId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    let url_ = this.baseUrl + "/api/Document/short/treatment/{treatmentId}";
    if (treatmentId === undefined || treatmentId === null)
      throw new globalThis.Error("The parameter 'treatmentId' must be defined.");
    url_ = url_.replace("{treatmentId}", encodeURIComponent("" + treatmentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetDocumentShortInfosForTreatment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDocumentShortInfosForTreatment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
    }));
  }

  protected processGetDocumentShortInfosForTreatment(response: HttpResponseBase): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DocumentShortInfoDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentShortInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getPinnedDocumentShortInfosForPet(petId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    let url_ = this.baseUrl + "/api/Document/short/pet/{petId}/pinnedDocuments";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPinnedDocumentShortInfosForPet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPinnedDocumentShortInfosForPet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
    }));
  }

  protected processGetPinnedDocumentShortInfosForPet(response: HttpResponseBase): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DocumentShortInfoDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentShortInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getPinnedDocumentShortInfosForCustomer(customerId: string): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    let url_ = this.baseUrl + "/api/Document/short/customer/{customerId}/pinnedDocuments";
    if (customerId === undefined || customerId === null)
      throw new globalThis.Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPinnedDocumentShortInfosForCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPinnedDocumentShortInfosForCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentShortInfoDto[]>>;
    }));
  }

  protected processGetPinnedDocumentShortInfosForCustomer(response: HttpResponseBase): Observable<SwaggerResponse<DocumentShortInfoDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DocumentShortInfoDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentShortInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getDocumentShortInfosById(documentId: string): Observable<SwaggerResponse<DocumentShortInfoDto>> {
    let url_ = this.baseUrl + "/api/Document/short/document/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetDocumentShortInfosById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDocumentShortInfosById(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentShortInfoDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentShortInfoDto>>;
    }));
  }

  protected processGetDocumentShortInfosById(response: HttpResponseBase): Observable<SwaggerResponse<DocumentShortInfoDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DocumentShortInfoDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentShortInfoDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getDocumentById(documentId: string): Observable<SwaggerResponse<DocumentDto>> {
    let url_ = this.baseUrl + "/api/Document/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetDocumentById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDocumentById(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<DocumentDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<DocumentDto>>;
    }));
  }

  protected processGetDocumentById(response: HttpResponseBase): Observable<SwaggerResponse<DocumentDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DocumentDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<DocumentDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  deleteDocument(documentId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Document/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeleteDocument(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteDocument(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processDeleteDocument(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  unpinDocument(documentId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Document/{documentId}/unpin";
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUnpinDocument(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUnpinDocument(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processUnpinDocument(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  pinDocument(documentId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Document/{documentId}/pin";
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processPinDocument(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPinDocument(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processPinDocument(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface IFeedbackClient {
  /**
   * @return Created
   */
  addFeedback(body: AddFeedbackDto): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  getAllFeedbackItems(): Observable<SwaggerResponse<FeedbackDto[]>>;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackClient implements IFeedbackClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return Created
   */
  addFeedback(body: AddFeedbackDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Feedback/add";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddFeedback(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddFeedback(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processAddFeedback(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getAllFeedbackItems(): Observable<SwaggerResponse<FeedbackDto[]>> {
    let url_ = this.baseUrl + "/api/Feedback/all";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllFeedbackItems(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllFeedbackItems(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<FeedbackDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<FeedbackDto[]>>;
    }));
  }

  protected processGetAllFeedbackItems(response: HttpResponseBase): Observable<SwaggerResponse<FeedbackDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(FeedbackDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<FeedbackDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface IHealthClient {
  /**
   * @return OK
   */
  health(): Observable<SwaggerResponse<HealthResponse>>;
}

@Injectable({
  providedIn: 'root'
})
export class HealthClient implements IHealthClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  health(): Observable<SwaggerResponse<HealthResponse>> {
    let url_ = this.baseUrl + "/api/Health";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processHealth(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHealth(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<HealthResponse>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<HealthResponse>>;
    }));
  }

  protected processHealth(response: HttpResponseBase): Observable<SwaggerResponse<HealthResponse>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = HealthResponse.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<HealthResponse>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface IIdentityClient {
  /**
   * @return OK
   */
  login(body: LoginRequestDto): Observable<SwaggerResponse<LoginResponseDto>>;
  /**
   * @return Created
   */
  register(body: RegisterRequestDto): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  userCheck(body: UserCheckRequestDto): Observable<SwaggerResponse<UserCheckResponseDto>>;
  /**
   * @return OK
   */
  setPassword(body: SetPasswordRequestDto): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  refresh(body: RefreshTokenRequestDto): Observable<SwaggerResponse<LoginResponseDto>>;
  /**
   * @return OK
   */
  logout(): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  changePassword(body: PasswordChangeRequestDto): Observable<SwaggerResponse<void>>;
}

@Injectable({
  providedIn: 'root'
})
export class IdentityClient implements IIdentityClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  login(body: LoginRequestDto): Observable<SwaggerResponse<LoginResponseDto>> {
    let url_ = this.baseUrl + "/api/Identity/login";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processLogin(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLogin(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<LoginResponseDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<LoginResponseDto>>;
    }));
  }

  protected processLogin(response: HttpResponseBase): Observable<SwaggerResponse<LoginResponseDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LoginResponseDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<LoginResponseDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  register(body: RegisterRequestDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Identity/register";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRegister(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRegister(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processRegister(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  userCheck(body: UserCheckRequestDto): Observable<SwaggerResponse<UserCheckResponseDto>> {
    let url_ = this.baseUrl + "/api/Identity/user-check";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUserCheck(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUserCheck(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<UserCheckResponseDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<UserCheckResponseDto>>;
    }));
  }

  protected processUserCheck(response: HttpResponseBase): Observable<SwaggerResponse<UserCheckResponseDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserCheckResponseDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<UserCheckResponseDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  setPassword(body: SetPasswordRequestDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Identity/set-password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processSetPassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSetPassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processSetPassword(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  refresh(body: RefreshTokenRequestDto): Observable<SwaggerResponse<LoginResponseDto>> {
    let url_ = this.baseUrl + "/api/Identity/refresh";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processRefresh(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRefresh(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<LoginResponseDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<LoginResponseDto>>;
    }));
  }

  protected processRefresh(response: HttpResponseBase): Observable<SwaggerResponse<LoginResponseDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LoginResponseDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<LoginResponseDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  logout(): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Identity/logout";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processLogout(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLogout(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processLogout(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  changePassword(body: PasswordChangeRequestDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Identity/change-password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processChangePassword(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangePassword(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processChangePassword(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface ILicenseClient {
  /**
   * @return OK
   */
  getLicensesForTenant(tenantId: string): Observable<SwaggerResponse<void>>;
  /**
   * @return Created
   */
  createLicenseForTenant(tenantId: string, featureSetId: string): Observable<SwaggerResponse<string>>;
  /**
   * @return OK
   */
  deleteLicenseForTenant(tenantId: string, licenseId: string): Observable<SwaggerResponse<void>>;
}

@Injectable({
  providedIn: 'root'
})
export class LicenseClient implements ILicenseClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  getLicensesForTenant(tenantId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/License/tenant/{tenantId}";
    if (tenantId === undefined || tenantId === null)
      throw new globalThis.Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetLicensesForTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLicensesForTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processGetLicensesForTenant(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  createLicenseForTenant(tenantId: string, featureSetId: string): Observable<SwaggerResponse<string>> {
    let url_ = this.baseUrl + "/api/License/tenant/{tenantId}/featureSet/{featureSetId}";
    if (tenantId === undefined || tenantId === null)
      throw new globalThis.Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    if (featureSetId === undefined || featureSetId === null)
      throw new globalThis.Error("The parameter 'featureSetId' must be defined.");
    url_ = url_.replace("{featureSetId}", encodeURIComponent("" + featureSetId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateLicenseForTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateLicenseForTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
    }));
  }

  protected processCreateLicenseForTenant(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : null as any;

        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  deleteLicenseForTenant(tenantId: string, licenseId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/License/tenant/{tenantId}/license/{licenseId}";
    if (tenantId === undefined || tenantId === null)
      throw new globalThis.Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    if (licenseId === undefined || licenseId === null)
      throw new globalThis.Error("The parameter 'licenseId' must be defined.");
    url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeleteLicenseForTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteLicenseForTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processDeleteLicenseForTenant(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface IPetClient {
  /**
   * @return OK
   */
  getPetById(petId: string): Observable<SwaggerResponse<PetDto>>;
  /**
   * @return OK
   */
  deletePet(petId: string): Observable<SwaggerResponse<void>>;
  /**
   * @return OK
   */
  getAllPetsForCustomer(customerId: string): Observable<SwaggerResponse<PetDto[]>>;
  /**
   * @return Created
   */
  createPet(body: CreatePetRequestDto): Observable<SwaggerResponse<string>>;
  /**
   * @return OK
   */
  updatePet(body: UpdatePetRequestDto): Observable<SwaggerResponse<void>>;
  /**
   * @return Created
   */
  addDocumentToPet(petId: string, body: DocumentDto): Observable<SwaggerResponse<IdResponse>>;
  /**
   * @return Created
   */
  addSkeletonAnnotationToPet(petId: string, body: ImageAnnotation): Observable<SwaggerResponse<IdResponse>>;
}

@Injectable({
  providedIn: 'root'
})
export class PetClient implements IPetClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  getPetById(petId: string): Observable<SwaggerResponse<PetDto>> {
    let url_ = this.baseUrl + "/api/Pet/{petId}";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetPetById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPetById(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<PetDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<PetDto>>;
    }));
  }

  protected processGetPetById(response: HttpResponseBase): Observable<SwaggerResponse<PetDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PetDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<PetDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  deletePet(petId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Pet/{petId}";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeletePet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeletePet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processDeletePet(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getAllPetsForCustomer(customerId: string): Observable<SwaggerResponse<PetDto[]>> {
    let url_ = this.baseUrl + "/api/Pet/customer/{customerId}";
    if (customerId === undefined || customerId === null)
      throw new globalThis.Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllPetsForCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllPetsForCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<PetDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<PetDto[]>>;
    }));
  }

  protected processGetAllPetsForCustomer(response: HttpResponseBase): Observable<SwaggerResponse<PetDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PetDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<PetDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  createPet(body: CreatePetRequestDto): Observable<SwaggerResponse<string>> {
    let url_ = this.baseUrl + "/api/Pet";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreatePet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreatePet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
    }));
  }

  protected processCreatePet(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : null as any;

        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  updatePet(body: UpdatePetRequestDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Pet";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUpdatePet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdatePet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processUpdatePet(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  addDocumentToPet(petId: string, body: DocumentDto): Observable<SwaggerResponse<IdResponse>> {
    let url_ = this.baseUrl + "/api/Pet/{petId}/document";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddDocumentToPet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddDocumentToPet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<IdResponse>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<IdResponse>>;
    }));
  }

  protected processAddDocumentToPet(response: HttpResponseBase): Observable<SwaggerResponse<IdResponse>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = IdResponse.fromJS(resultData201);
        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<IdResponse>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  addSkeletonAnnotationToPet(petId: string, body: ImageAnnotation): Observable<SwaggerResponse<IdResponse>> {
    let url_ = this.baseUrl + "/api/Pet/{petId}/skeletonAnnotation";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddSkeletonAnnotationToPet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddSkeletonAnnotationToPet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<IdResponse>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<IdResponse>>;
    }));
  }

  protected processAddSkeletonAnnotationToPet(response: HttpResponseBase): Observable<SwaggerResponse<IdResponse>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = IdResponse.fromJS(resultData201);
        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<IdResponse>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface ITenantClient {
  /**
   * @return OK
   */
  addUserToTenant(tenantId: string, userId: string): Observable<SwaggerResponse<void>>;
  /**
   * @return Created
   */
  createTenant(body: CreateTenantRequestDto): Observable<SwaggerResponse<string>>;
  /**
   * @return OK
   */
  getAllTenants(): Observable<SwaggerResponse<TenantDto[]>>;
  /**
   * @return OK
   */
  updateTenant(body: UpdateTenantRequestDto): Observable<SwaggerResponse<void>>;
  /**
   * @return Created
   */
  getCountryForTenant(): Observable<SwaggerResponse<string>>;
  /**
   * @return OK
   */
  deleteTenant(tenantId: string): Observable<SwaggerResponse<void>>;
}

@Injectable({
  providedIn: 'root'
})
export class TenantClient implements ITenantClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  addUserToTenant(tenantId: string, userId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Tenant/{tenantId}/addUser/{userId}";
    if (tenantId === undefined || tenantId === null)
      throw new globalThis.Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    if (userId === undefined || userId === null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddUserToTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddUserToTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processAddUserToTenant(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  createTenant(body: CreateTenantRequestDto): Observable<SwaggerResponse<string>> {
    let url_ = this.baseUrl + "/api/Tenant";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
    }));
  }

  protected processCreateTenant(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : null as any;

        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getAllTenants(): Observable<SwaggerResponse<TenantDto[]>> {
    let url_ = this.baseUrl + "/api/Tenant";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllTenants(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllTenants(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<TenantDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<TenantDto[]>>;
    }));
  }

  protected processGetAllTenants(response: HttpResponseBase): Observable<SwaggerResponse<TenantDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(TenantDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<TenantDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  updateTenant(body: UpdateTenantRequestDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Tenant";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUpdateTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processUpdateTenant(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  getCountryForTenant(): Observable<SwaggerResponse<string>> {
    let url_ = this.baseUrl + "/api/Tenant/country";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetCountryForTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCountryForTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
    }));
  }

  protected processGetCountryForTenant(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : null as any;

        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  deleteTenant(tenantId: string): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Tenant/{tenantId}";
    if (tenantId === undefined || tenantId === null)
      throw new globalThis.Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processDeleteTenant(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteTenant(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processDeleteTenant(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface ITranslationClient {
  /**
   * @return OK
   */
  getTranslation(language: string): Observable<SwaggerResponse<{ [key: string]: string; }>>;
}

@Injectable({
  providedIn: 'root'
})
export class TranslationClient implements ITranslationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  getTranslation(language: string): Observable<SwaggerResponse<{ [key: string]: string; }>> {
    let url_ = this.baseUrl + "/api/Translation/{language}";
    if (language === undefined || language === null)
      throw new globalThis.Error("The parameter 'language' must be defined.");
    url_ = url_.replace("{language}", encodeURIComponent("" + language));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTranslation(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTranslation(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<{ [key: string]: string; }>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<{ [key: string]: string; }>>;
    }));
  }

  protected processGetTranslation(response: HttpResponseBase): Observable<SwaggerResponse<{ [key: string]: string; }>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (resultData200) {
          result200 = {} as any;
          for (let key in resultData200) {
            if (resultData200.hasOwnProperty(key))
              (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
          }
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<{ [key: string]: string; }>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface ITreatmentClient {
  /**
   * @return OK
   */
  getTreatmentsForPet(petId: string): Observable<SwaggerResponse<TreatmentDto[]>>;
  /**
   * @return Created
   */
  createTreatmentForPet(petId: string, body: CreateTreatmentRequestDto): Observable<SwaggerResponse<string>>;
  /**
   * @return OK
   */
  getTreatmentById(treatmentId: string): Observable<SwaggerResponse<TreatmentDto>>;
  /**
   * @return OK
   */
  getBatchTreatments(body: string[]): Observable<SwaggerResponse<TreatmentDto[]>>;
  /**
   * @return OK
   */
  getTreatmentsForCustomer(customerId: string): Observable<SwaggerResponse<TreatmentShortInfoDto[]>>;
  /**
   * @return OK
   */
  getAllTreatmentsForTenantInMonth(month: number): Observable<SwaggerResponse<TreatmentShortInfoDto[]>>;
  /**
   * @return OK
   */
  updateTreatment(body: UpdateTreatmentRequestDto): Observable<SwaggerResponse<void>>;
  /**
   * @return Created
   */
  addDocumentToTreatment(treatmentId: string, body: DocumentDto): Observable<SwaggerResponse<void>>;
}

@Injectable({
  providedIn: 'root'
})
export class TreatmentClient implements ITreatmentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  getTreatmentsForPet(petId: string): Observable<SwaggerResponse<TreatmentDto[]>> {
    let url_ = this.baseUrl + "/api/Treatment/pet/{petId}";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTreatmentsForPet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTreatmentsForPet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<TreatmentDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<TreatmentDto[]>>;
    }));
  }

  protected processGetTreatmentsForPet(response: HttpResponseBase): Observable<SwaggerResponse<TreatmentDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(TreatmentDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<TreatmentDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  createTreatmentForPet(petId: string, body: CreateTreatmentRequestDto): Observable<SwaggerResponse<string>> {
    let url_ = this.baseUrl + "/api/Treatment/pet/{petId}";
    if (petId === undefined || petId === null)
      throw new globalThis.Error("The parameter 'petId' must be defined.");
    url_ = url_.replace("{petId}", encodeURIComponent("" + petId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processCreateTreatmentForPet(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateTreatmentForPet(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
    }));
  }

  protected processCreateTreatmentForPet(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : null as any;

        return _observableOf(new SwaggerResponse(status, _headers, result201));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getTreatmentById(treatmentId: string): Observable<SwaggerResponse<TreatmentDto>> {
    let url_ = this.baseUrl + "/api/Treatment/{treatmentId}";
    if (treatmentId === undefined || treatmentId === null)
      throw new globalThis.Error("The parameter 'treatmentId' must be defined.");
    url_ = url_.replace("{treatmentId}", encodeURIComponent("" + treatmentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTreatmentById(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTreatmentById(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<TreatmentDto>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<TreatmentDto>>;
    }));
  }

  protected processGetTreatmentById(response: HttpResponseBase): Observable<SwaggerResponse<TreatmentDto>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TreatmentDto.fromJS(resultData200);
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<TreatmentDto>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getBatchTreatments(body: string[]): Observable<SwaggerResponse<TreatmentDto[]>> {
    let url_ = this.baseUrl + "/api/Treatment/batch";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetBatchTreatments(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetBatchTreatments(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<TreatmentDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<TreatmentDto[]>>;
    }));
  }

  protected processGetBatchTreatments(response: HttpResponseBase): Observable<SwaggerResponse<TreatmentDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(TreatmentDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<TreatmentDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getTreatmentsForCustomer(customerId: string): Observable<SwaggerResponse<TreatmentShortInfoDto[]>> {
    let url_ = this.baseUrl + "/api/Treatment/customer/{customerId}";
    if (customerId === undefined || customerId === null)
      throw new globalThis.Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetTreatmentsForCustomer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTreatmentsForCustomer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<TreatmentShortInfoDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<TreatmentShortInfoDto[]>>;
    }));
  }

  protected processGetTreatmentsForCustomer(response: HttpResponseBase): Observable<SwaggerResponse<TreatmentShortInfoDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(TreatmentShortInfoDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<TreatmentShortInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  getAllTreatmentsForTenantInMonth(month: number): Observable<SwaggerResponse<TreatmentShortInfoDto[]>> {
    let url_ = this.baseUrl + "/api/Treatment/month/{month}";
    if (month === undefined || month === null)
      throw new globalThis.Error("The parameter 'month' must be defined.");
    url_ = url_.replace("{month}", encodeURIComponent("" + month));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllTreatmentsForTenantInMonth(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllTreatmentsForTenantInMonth(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<TreatmentShortInfoDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<TreatmentShortInfoDto[]>>;
    }));
  }

  protected processGetAllTreatmentsForTenantInMonth(response: HttpResponseBase): Observable<SwaggerResponse<TreatmentShortInfoDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(TreatmentShortInfoDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<TreatmentShortInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return OK
   */
  updateTreatment(body: UpdateTreatmentRequestDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Treatment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processUpdateTreatment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateTreatment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processUpdateTreatment(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }

  /**
   * @return Created
   */
  addDocumentToTreatment(treatmentId: string, body: DocumentDto): Observable<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/api/Treatment/{treatmentId}/document";
    if (treatmentId === undefined || treatmentId === null)
      throw new globalThis.Error("The parameter 'treatmentId' must be defined.");
    url_ = url_.replace("{treatmentId}", encodeURIComponent("" + treatmentId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processAddDocumentToTreatment(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAddDocumentToTreatment(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
    }));
  }

  protected processAddDocumentToTreatment(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export interface IUserClient {
  /**
   * @return OK
   */
  getAllUsers(): Observable<SwaggerResponse<UserDto[]>>;
}

@Injectable({
  providedIn: 'root'
})
export class UserClient implements IUserClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "http://localhost:44314/";
  }

  /**
   * @return OK
   */
  getAllUsers(): Observable<SwaggerResponse<UserDto[]>> {
    let url_ = this.baseUrl + "/api/User";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
      return this.processGetAllUsers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllUsers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwaggerResponse<UserDto[]>>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwaggerResponse<UserDto[]>>;
    }));
  }

  protected processGetAllUsers(response: HttpResponseBase): Observable<SwaggerResponse<UserDto[]>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(UserDto.fromJS(item));
        }
        else {
          result200 = null as any;
        }
        return _observableOf(new SwaggerResponse(status, _headers, result200));
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Internal Server Error", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SwaggerResponse<UserDto[]>>(new SwaggerResponse(status, _headers, null as any));
  }
}

export class AddFeedbackDto implements IAddFeedbackDto {
  feedbackType!: FeedbackType;
  feedbackSeverity!: FeedbackSeverityType;
  errorSeverity!: ErrorSeverityType;
  missingFeatureSeverity!: MissingFeatureSeverityType;
  description!: string;
  concerningPage!: string;
  concerningPetId!: string | undefined;
  concerningTreatmentId!: string | undefined;
  concerningCustomerId!: string | undefined;
  hasPermissionToAccessData!: boolean;
  hasPermissionToContact!: boolean;
  userAgent!: string;
  viewPortHeight!: number;
  viewPortWidth!: number;
  frontendVersion!: string;
  backendVersion!: string;

  [key: string]: any;

  constructor(data?: IAddFeedbackDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.feedbackType = _data["feedbackType"];
      this.feedbackSeverity = _data["feedbackSeverity"];
      this.errorSeverity = _data["errorSeverity"];
      this.missingFeatureSeverity = _data["missingFeatureSeverity"];
      this.description = _data["description"];
      this.concerningPage = _data["concerningPage"];
      this.concerningPetId = _data["concerningPetId"];
      this.concerningTreatmentId = _data["concerningTreatmentId"];
      this.concerningCustomerId = _data["concerningCustomerId"];
      this.hasPermissionToAccessData = _data["hasPermissionToAccessData"];
      this.hasPermissionToContact = _data["hasPermissionToContact"];
      this.userAgent = _data["userAgent"];
      this.viewPortHeight = _data["viewPortHeight"];
      this.viewPortWidth = _data["viewPortWidth"];
      this.frontendVersion = _data["frontendVersion"];
      this.backendVersion = _data["backendVersion"];
    }
  }

  static fromJS(data: any): AddFeedbackDto {
    data = typeof data === 'object' ? data : {};
    let result = new AddFeedbackDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["feedbackType"] = this.feedbackType;
    data["feedbackSeverity"] = this.feedbackSeverity;
    data["errorSeverity"] = this.errorSeverity;
    data["missingFeatureSeverity"] = this.missingFeatureSeverity;
    data["description"] = this.description;
    data["concerningPage"] = this.concerningPage;
    data["concerningPetId"] = this.concerningPetId;
    data["concerningTreatmentId"] = this.concerningTreatmentId;
    data["concerningCustomerId"] = this.concerningCustomerId;
    data["hasPermissionToAccessData"] = this.hasPermissionToAccessData;
    data["hasPermissionToContact"] = this.hasPermissionToContact;
    data["userAgent"] = this.userAgent;
    data["viewPortHeight"] = this.viewPortHeight;
    data["viewPortWidth"] = this.viewPortWidth;
    data["frontendVersion"] = this.frontendVersion;
    data["backendVersion"] = this.backendVersion;
    return data;
  }
}

export interface IAddFeedbackDto {
  feedbackType: FeedbackType;
  feedbackSeverity: FeedbackSeverityType;
  errorSeverity: ErrorSeverityType;
  missingFeatureSeverity: MissingFeatureSeverityType;
  description: string;
  concerningPage: string;
  concerningPetId: string | undefined;
  concerningTreatmentId: string | undefined;
  concerningCustomerId: string | undefined;
  hasPermissionToAccessData: boolean;
  hasPermissionToContact: boolean;
  userAgent: string;
  viewPortHeight: number;
  viewPortWidth: number;
  frontendVersion: string;
  backendVersion: string;

  [key: string]: any;
}

export class CreateCustomerRequestDto implements ICreateCustomerRequestDto {
  firstName!: string;
  lastName!: string;
  company!: string;
  eMail!: string;
  phoneNumber!: string;
  street!: string | undefined;
  houseNumber!: string | undefined;
  postalCode!: string;
  city!: string;
  country!: string;
  notes!: string;

  [key: string]: any;

  constructor(data?: ICreateCustomerRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.company = _data["company"];
      this.eMail = _data["eMail"];
      this.phoneNumber = _data["phoneNumber"];
      this.street = _data["street"];
      this.houseNumber = _data["houseNumber"];
      this.postalCode = _data["postalCode"];
      this.city = _data["city"];
      this.country = _data["country"];
      this.notes = _data["notes"];
    }
  }

  static fromJS(data: any): CreateCustomerRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateCustomerRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["company"] = this.company;
    data["eMail"] = this.eMail;
    data["phoneNumber"] = this.phoneNumber;
    data["street"] = this.street;
    data["houseNumber"] = this.houseNumber;
    data["postalCode"] = this.postalCode;
    data["city"] = this.city;
    data["country"] = this.country;
    data["notes"] = this.notes;
    return data;
  }
}

export interface ICreateCustomerRequestDto {
  firstName: string;
  lastName: string;
  company: string;
  eMail: string;
  phoneNumber: string;
  street: string | undefined;
  houseNumber: string | undefined;
  postalCode: string;
  city: string;
  country: string;
  notes: string;

  [key: string]: any;
}

export class CreatePetRequestDto implements ICreatePetRequestDto {
  chipNumber!: string;
  nickname!: string;
  hasBreederGivenName!: boolean;
  breederGivenName!: string | undefined;
  anamnesis!: string;
  dateOfBirth!: DateTime;
  color!: string;
  race!: string;
  behavior!: PetBehavior;
  behaviorText!: string;
  ownerId!: string;
  species!: Species;
  neuteringStatus!: NeuteringStatus;
  gender!: Gender;
  isInsured!: boolean;
  insuranceProvider!: string | undefined;
  insuranceNumber!: string | undefined;
  hasHomeVet!: boolean;
  homeVet!: Veterinarian | undefined;
  firstTreatmentDate!: DateTime;

  [key: string]: any;

  constructor(data?: ICreatePetRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.chipNumber = _data["chipNumber"];
      this.nickname = _data["nickname"];
      this.hasBreederGivenName = _data["hasBreederGivenName"];
      this.breederGivenName = _data["breederGivenName"];
      this.anamnesis = _data["anamnesis"];
      this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : undefined as any;
      this.color = _data["color"];
      this.race = _data["race"];
      this.behavior = _data["behavior"];
      this.behaviorText = _data["behaviorText"];
      this.ownerId = _data["ownerId"];
      this.species = _data["species"];
      this.neuteringStatus = _data["neuteringStatus"];
      this.gender = _data["gender"];
      this.isInsured = _data["isInsured"];
      this.insuranceProvider = _data["insuranceProvider"];
      this.insuranceNumber = _data["insuranceNumber"];
      this.hasHomeVet = _data["hasHomeVet"];
      this.homeVet = _data["homeVet"] ? Veterinarian.fromJS(_data["homeVet"]) : undefined as any;
      this.firstTreatmentDate = _data["firstTreatmentDate"] ? DateTime.fromISO(_data["firstTreatmentDate"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): CreatePetRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePetRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["chipNumber"] = this.chipNumber;
    data["nickname"] = this.nickname;
    data["hasBreederGivenName"] = this.hasBreederGivenName;
    data["breederGivenName"] = this.breederGivenName;
    data["anamnesis"] = this.anamnesis;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : undefined as any;
    data["color"] = this.color;
    data["race"] = this.race;
    data["behavior"] = this.behavior;
    data["behaviorText"] = this.behaviorText;
    data["ownerId"] = this.ownerId;
    data["species"] = this.species;
    data["neuteringStatus"] = this.neuteringStatus;
    data["gender"] = this.gender;
    data["isInsured"] = this.isInsured;
    data["insuranceProvider"] = this.insuranceProvider;
    data["insuranceNumber"] = this.insuranceNumber;
    data["hasHomeVet"] = this.hasHomeVet;
    data["homeVet"] = this.homeVet ? this.homeVet.toJSON() : undefined as any;
    data["firstTreatmentDate"] = this.firstTreatmentDate ? this.firstTreatmentDate.toString() : undefined as any;
    return data;
  }
}

export interface ICreatePetRequestDto {
  chipNumber: string;
  nickname: string;
  hasBreederGivenName: boolean;
  breederGivenName: string | undefined;
  anamnesis: string;
  dateOfBirth: DateTime;
  color: string;
  race: string;
  behavior: PetBehavior;
  behaviorText: string;
  ownerId: string;
  species: Species;
  neuteringStatus: NeuteringStatus;
  gender: Gender;
  isInsured: boolean;
  insuranceProvider: string | undefined;
  insuranceNumber: string | undefined;
  hasHomeVet: boolean;
  homeVet: Veterinarian | undefined;
  firstTreatmentDate: DateTime;

  [key: string]: any;
}

export class CreateTenantRequestDto implements ICreateTenantRequestDto {
  name!: string;
  contactName!: string;
  contactPhone!: string;
  street!: string;
  houseNumber!: string;
  postalCode!: string;
  city!: string;
  country!: string;

  [key: string]: any;

  constructor(data?: ICreateTenantRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.name = _data["name"];
      this.contactName = _data["contactName"];
      this.contactPhone = _data["contactPhone"];
      this.street = _data["street"];
      this.houseNumber = _data["houseNumber"];
      this.postalCode = _data["postalCode"];
      this.city = _data["city"];
      this.country = _data["country"];
    }
  }

  static fromJS(data: any): CreateTenantRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateTenantRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["name"] = this.name;
    data["contactName"] = this.contactName;
    data["contactPhone"] = this.contactPhone;
    data["street"] = this.street;
    data["houseNumber"] = this.houseNumber;
    data["postalCode"] = this.postalCode;
    data["city"] = this.city;
    data["country"] = this.country;
    return data;
  }
}

export interface ICreateTenantRequestDto {
  name: string;
  contactName: string;
  contactPhone: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;

  [key: string]: any;
}

export class CreateTreatmentRequestDto implements ICreateTreatmentRequestDto {
  description!: string;
  appointmentDate!: DateTime;
  customerId!: string;
  title!: string;

  [key: string]: any;

  constructor(data?: ICreateTreatmentRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.description = _data["description"];
      this.appointmentDate = _data["appointmentDate"] ? DateTime.fromISO(_data["appointmentDate"].toString()) : undefined as any;
      this.customerId = _data["customerId"];
      this.title = _data["title"];
    }
  }

  static fromJS(data: any): CreateTreatmentRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateTreatmentRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["description"] = this.description;
    data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toString() : undefined as any;
    data["customerId"] = this.customerId;
    data["title"] = this.title;
    return data;
  }
}

export interface ICreateTreatmentRequestDto {
  description: string;
  appointmentDate: DateTime;
  customerId: string;
  title: string;

  [key: string]: any;
}

export class CustomerDto implements ICustomerDto {
  id!: string;
  firstName!: string;
  lastName!: string;
  eMail!: string;
  phoneNumber!: string;
  street!: string;
  houseNumber!: string;
  postalCode!: string;
  city!: string;
  country!: string;
  petIds!: string[];
  tenantId!: string;
  treatmentIds!: string[];
  notes!: string;
  company!: string;
  createdAt!: DateTime;
  createdBy!: string;
  modifiedAt!: DateTime | undefined;
  modifiedBy!: string | undefined;
  markedAsDeletable!: boolean;
  deletedAt!: DateTime | undefined;
  deletedBy!: string | undefined;

  [key: string]: any;

  constructor(data?: ICustomerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.eMail = _data["eMail"];
      this.phoneNumber = _data["phoneNumber"];
      this.street = _data["street"];
      this.houseNumber = _data["houseNumber"];
      this.postalCode = _data["postalCode"];
      this.city = _data["city"];
      this.country = _data["country"];
      if (Array.isArray(_data["petIds"])) {
        this.petIds = [] as any;
        for (let item of _data["petIds"])
          this.petIds!.push(item);
      }
      this.tenantId = _data["tenantId"];
      if (Array.isArray(_data["treatmentIds"])) {
        this.treatmentIds = [] as any;
        for (let item of _data["treatmentIds"])
          this.treatmentIds!.push(item);
      }
      this.notes = _data["notes"];
      this.company = _data["company"];
      this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
      this.createdBy = _data["createdBy"];
      this.modifiedAt = _data["modifiedAt"] ? DateTime.fromISO(_data["modifiedAt"].toString()) : undefined as any;
      this.modifiedBy = _data["modifiedBy"];
      this.markedAsDeletable = _data["markedAsDeletable"];
      this.deletedAt = _data["deletedAt"] ? DateTime.fromISO(_data["deletedAt"].toString()) : undefined as any;
      this.deletedBy = _data["deletedBy"];
    }
  }

  static fromJS(data: any): CustomerDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["eMail"] = this.eMail;
    data["phoneNumber"] = this.phoneNumber;
    data["street"] = this.street;
    data["houseNumber"] = this.houseNumber;
    data["postalCode"] = this.postalCode;
    data["city"] = this.city;
    data["country"] = this.country;
    if (Array.isArray(this.petIds)) {
      data["petIds"] = [];
      for (let item of this.petIds)
        data["petIds"].push(item);
    }
    data["tenantId"] = this.tenantId;
    if (Array.isArray(this.treatmentIds)) {
      data["treatmentIds"] = [];
      for (let item of this.treatmentIds)
        data["treatmentIds"].push(item);
    }
    data["notes"] = this.notes;
    data["company"] = this.company;
    data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
    data["createdBy"] = this.createdBy;
    data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toString() : undefined as any;
    data["modifiedBy"] = this.modifiedBy;
    data["markedAsDeletable"] = this.markedAsDeletable;
    data["deletedAt"] = this.deletedAt ? this.deletedAt.toString() : undefined as any;
    data["deletedBy"] = this.deletedBy;
    return data;
  }
}

export interface ICustomerDto {
  id: string;
  firstName: string;
  lastName: string;
  eMail: string;
  phoneNumber: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;
  petIds: string[];
  tenantId: string;
  treatmentIds: string[];
  notes: string;
  company: string;
  createdAt: DateTime;
  createdBy: string;
  modifiedAt: DateTime | undefined;
  modifiedBy: string | undefined;
  markedAsDeletable: boolean;
  deletedAt: DateTime | undefined;
  deletedBy: string | undefined;

  [key: string]: any;
}

export class CustomerNameDto implements ICustomerNameDto {
  id!: string;
  firstName!: string;
  lastName!: string;

  [key: string]: any;

  constructor(data?: ICustomerNameDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
    }
  }

  static fromJS(data: any): CustomerNameDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerNameDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    return data;
  }
}

export interface ICustomerNameDto {
  id: string;
  firstName: string;
  lastName: string;

  [key: string]: any;
}

export class DocumentDto implements IDocumentDto {
  id!: string | undefined;
  filename!: string;
  base64Data!: string;
  mimeType!: string;
  isPinned!: boolean;
  documentType!: DocumentType;
  creationDate!: DateTime;
  annotation!: ImageAnnotation | undefined;

  [key: string]: any;

  constructor(data?: IDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.filename = _data["filename"];
      this.base64Data = _data["base64Data"];
      this.mimeType = _data["mimeType"];
      this.isPinned = _data["isPinned"];
      this.documentType = _data["documentType"];
      this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : undefined as any;
      this.annotation = _data["annotation"] ? ImageAnnotation.fromJS(_data["annotation"]) : undefined as any;
    }
  }

  static fromJS(data: any): DocumentDto {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["filename"] = this.filename;
    data["base64Data"] = this.base64Data;
    data["mimeType"] = this.mimeType;
    data["isPinned"] = this.isPinned;
    data["documentType"] = this.documentType;
    data["creationDate"] = this.creationDate ? this.creationDate.toString() : undefined as any;
    data["annotation"] = this.annotation ? this.annotation.toJSON() : undefined as any;
    return data;
  }
}

export interface IDocumentDto {
  id: string | undefined;
  filename: string;
  base64Data: string;
  mimeType: string;
  isPinned: boolean;
  documentType: DocumentType;
  creationDate: DateTime;
  annotation: ImageAnnotation | undefined;

  [key: string]: any;
}

export class DocumentShortInfoDto implements IDocumentShortInfoDto {
  id!: string;
  filename!: string;
  thumbailBase64Data!: string;
  mimeType!: string;
  isPinned!: boolean;
  documentType!: DocumentType;
  creationDate!: DateTime;
  hasAnnotation!: boolean;

  [key: string]: any;

  constructor(data?: IDocumentShortInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.filename = _data["filename"];
      this.thumbailBase64Data = _data["thumbailBase64Data"];
      this.mimeType = _data["mimeType"];
      this.isPinned = _data["isPinned"];
      this.documentType = _data["documentType"];
      this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : undefined as any;
      this.hasAnnotation = _data["hasAnnotation"];
    }
  }

  static fromJS(data: any): DocumentShortInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentShortInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["filename"] = this.filename;
    data["thumbailBase64Data"] = this.thumbailBase64Data;
    data["mimeType"] = this.mimeType;
    data["isPinned"] = this.isPinned;
    data["documentType"] = this.documentType;
    data["creationDate"] = this.creationDate ? this.creationDate.toString() : undefined as any;
    data["hasAnnotation"] = this.hasAnnotation;
    return data;
  }
}

export interface IDocumentShortInfoDto {
  id: string;
  filename: string;
  thumbailBase64Data: string;
  mimeType: string;
  isPinned: boolean;
  documentType: DocumentType;
  creationDate: DateTime;
  hasAnnotation: boolean;

  [key: string]: any;
}

export type DocumentType = "Unknown" | "Image" | "Document";

export type ErrorSeverityType = "Unknown" | "Annoyance" | "Disturbing" | "Critical";

export class FeedbackDto implements IFeedbackDto {
  id!: string;
  feedbackType!: FeedbackType;
  concerningUserName!: string;
  feedbackSeverity!: FeedbackSeverityType;
  errorSeverity!: ErrorSeverityType;
  missingFeatureSeverity!: MissingFeatureSeverityType;
  description!: string;
  concerningPage!: string;
  concerningPetId!: string | undefined;
  concerningTreatmentId!: string | undefined;
  concerningCustomerId!: string | undefined;
  hasPermissionToAccessData!: boolean;
  hasPermissionToContact!: boolean;
  userAgent!: string;
  viewPortHeight!: number;
  viewPortWidth!: number;
  frontendVersion!: string;
  backendVersion!: string;

  [key: string]: any;

  constructor(data?: IFeedbackDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.feedbackType = _data["feedbackType"];
      this.concerningUserName = _data["concerningUserName"];
      this.feedbackSeverity = _data["feedbackSeverity"];
      this.errorSeverity = _data["errorSeverity"];
      this.missingFeatureSeverity = _data["missingFeatureSeverity"];
      this.description = _data["description"];
      this.concerningPage = _data["concerningPage"];
      this.concerningPetId = _data["concerningPetId"];
      this.concerningTreatmentId = _data["concerningTreatmentId"];
      this.concerningCustomerId = _data["concerningCustomerId"];
      this.hasPermissionToAccessData = _data["hasPermissionToAccessData"];
      this.hasPermissionToContact = _data["hasPermissionToContact"];
      this.userAgent = _data["userAgent"];
      this.viewPortHeight = _data["viewPortHeight"];
      this.viewPortWidth = _data["viewPortWidth"];
      this.frontendVersion = _data["frontendVersion"];
      this.backendVersion = _data["backendVersion"];
    }
  }

  static fromJS(data: any): FeedbackDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeedbackDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["feedbackType"] = this.feedbackType;
    data["concerningUserName"] = this.concerningUserName;
    data["feedbackSeverity"] = this.feedbackSeverity;
    data["errorSeverity"] = this.errorSeverity;
    data["missingFeatureSeverity"] = this.missingFeatureSeverity;
    data["description"] = this.description;
    data["concerningPage"] = this.concerningPage;
    data["concerningPetId"] = this.concerningPetId;
    data["concerningTreatmentId"] = this.concerningTreatmentId;
    data["concerningCustomerId"] = this.concerningCustomerId;
    data["hasPermissionToAccessData"] = this.hasPermissionToAccessData;
    data["hasPermissionToContact"] = this.hasPermissionToContact;
    data["userAgent"] = this.userAgent;
    data["viewPortHeight"] = this.viewPortHeight;
    data["viewPortWidth"] = this.viewPortWidth;
    data["frontendVersion"] = this.frontendVersion;
    data["backendVersion"] = this.backendVersion;
    return data;
  }
}

export interface IFeedbackDto {
  id: string;
  feedbackType: FeedbackType;
  concerningUserName: string;
  feedbackSeverity: FeedbackSeverityType;
  errorSeverity: ErrorSeverityType;
  missingFeatureSeverity: MissingFeatureSeverityType;
  description: string;
  concerningPage: string;
  concerningPetId: string | undefined;
  concerningTreatmentId: string | undefined;
  concerningCustomerId: string | undefined;
  hasPermissionToAccessData: boolean;
  hasPermissionToContact: boolean;
  userAgent: string;
  viewPortHeight: number;
  viewPortWidth: number;
  frontendVersion: string;
  backendVersion: string;

  [key: string]: any;
}

export type FeedbackSeverityType = "Unknown" | "VeryGood" | "Good" | "Problematic" | "Critical";

export type FeedbackType = "Unknown" | "Feedback" | "Error" | "MissingFeature";

export type Gender = "Unknown" | "Female" | "Male";

export class HealthResponse implements IHealthResponse {
  healthy!: boolean;
  version!: string;

  [key: string]: any;

  constructor(data?: IHealthResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.healthy = _data["healthy"];
      this.version = _data["version"];
    }
  }

  static fromJS(data: any): HealthResponse {
    data = typeof data === 'object' ? data : {};
    let result = new HealthResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["healthy"] = this.healthy;
    data["version"] = this.version;
    return data;
  }
}

export interface IHealthResponse {
  healthy: boolean;
  version: string;

  [key: string]: any;
}

export class IdResponse implements IIdResponse {
  id!: string;

  [key: string]: any;

  constructor(data?: IIdResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): IdResponse {
    data = typeof data === 'object' ? data : {};
    let result = new IdResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    return data;
  }
}

export interface IIdResponse {
  id: string;

  [key: string]: any;
}

export class ImageAnnotation implements IImageAnnotation {
  annotationElements!: ImageAnnotationElement[];
  legendElements!: TupleOfstringAndstring[];

  [key: string]: any;

  constructor(data?: IImageAnnotation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      if (Array.isArray(_data["annotationElements"])) {
        this.annotationElements = [] as any;
        for (let item of _data["annotationElements"])
          this.annotationElements!.push(ImageAnnotationElement.fromJS(item));
      }
      if (Array.isArray(_data["legendElements"])) {
        this.legendElements = [] as any;
        for (let item of _data["legendElements"])
          this.legendElements!.push(TupleOfstringAndstring.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ImageAnnotation {
    data = typeof data === 'object' ? data : {};
    let result = new ImageAnnotation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    if (Array.isArray(this.annotationElements)) {
      data["annotationElements"] = [];
      for (let item of this.annotationElements)
        data["annotationElements"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.legendElements)) {
      data["legendElements"] = [];
      for (let item of this.legendElements)
        data["legendElements"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IImageAnnotation {
  annotationElements: ImageAnnotationElement[];
  legendElements: TupleOfstringAndstring[];

  [key: string]: any;
}

export class ImageAnnotationElement implements IImageAnnotationElement {
  type!: ImageAnnotationElementType;
  freehandPoints!: TupleOfintAndint[] | undefined;
  thicknessPx!: number;
  color!: string;
  circleCenter!: TupleOfintAndint | undefined;
  circleRadiusPx!: number | undefined;

  [key: string]: any;

  constructor(data?: IImageAnnotationElement) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.type = _data["type"];
      if (Array.isArray(_data["freehandPoints"])) {
        this.freehandPoints = [] as any;
        for (let item of _data["freehandPoints"])
          this.freehandPoints!.push(TupleOfintAndint.fromJS(item));
      }
      this.thicknessPx = _data["thicknessPx"];
      this.color = _data["color"];
      this.circleCenter = _data["circleCenter"] ? TupleOfintAndint.fromJS(_data["circleCenter"]) : undefined as any;
      this.circleRadiusPx = _data["circleRadiusPx"];
    }
  }

  static fromJS(data: any): ImageAnnotationElement {
    data = typeof data === 'object' ? data : {};
    let result = new ImageAnnotationElement();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["type"] = this.type;
    if (Array.isArray(this.freehandPoints)) {
      data["freehandPoints"] = [];
      for (let item of this.freehandPoints)
        data["freehandPoints"].push(item ? item.toJSON() : undefined as any);
    }
    data["thicknessPx"] = this.thicknessPx;
    data["color"] = this.color;
    data["circleCenter"] = this.circleCenter ? this.circleCenter.toJSON() : undefined as any;
    data["circleRadiusPx"] = this.circleRadiusPx;
    return data;
  }
}

export interface IImageAnnotationElement {
  type: ImageAnnotationElementType;
  freehandPoints: TupleOfintAndint[] | undefined;
  thicknessPx: number;
  color: string;
  circleCenter: TupleOfintAndint | undefined;
  circleRadiusPx: number | undefined;

  [key: string]: any;
}

export type ImageAnnotationElementType = "Circle" | "Freehand";

export class LoginRequestDto implements ILoginRequestDto {
  username!: string;
  password!: string;
  language!: string;
  twoFactorCode!: string | undefined;
  twoFactorRecoveryCode!: string | undefined;

  [key: string]: any;

  constructor(data?: ILoginRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.username = _data["username"];
      this.password = _data["password"];
      this.language = _data["language"];
      this.twoFactorCode = _data["twoFactorCode"];
      this.twoFactorRecoveryCode = _data["twoFactorRecoveryCode"];
    }
  }

  static fromJS(data: any): LoginRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new LoginRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["username"] = this.username;
    data["password"] = this.password;
    data["language"] = this.language;
    data["twoFactorCode"] = this.twoFactorCode;
    data["twoFactorRecoveryCode"] = this.twoFactorRecoveryCode;
    return data;
  }
}

export interface ILoginRequestDto {
  username: string;
  password: string;
  language: string;
  twoFactorCode: string | undefined;
  twoFactorRecoveryCode: string | undefined;

  [key: string]: any;
}

export class LoginResponseDto implements ILoginResponseDto {
  accessToken!: string;
  refreshToken!: string;

  [key: string]: any;

  constructor(data?: ILoginResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.accessToken = _data["accessToken"];
      this.refreshToken = _data["refreshToken"];
    }
  }

  static fromJS(data: any): LoginResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new LoginResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["accessToken"] = this.accessToken;
    data["refreshToken"] = this.refreshToken;
    return data;
  }
}

export interface ILoginResponseDto {
  accessToken: string;
  refreshToken: string;

  [key: string]: any;
}

export type MissingFeatureSeverityType = "Unknown" | "NiceToHave" | "Important" | "Essential";

export type NeuteringStatus = "Unknown" | "Neutered" | "NotNeutered";

export class PasswordChangeRequestDto implements IPasswordChangeRequestDto {
  username!: string | undefined;
  email!: string | undefined;
  currentPassword!: string;
  newPassword!: string;
  passwordConfirmation!: string;

  [key: string]: any;

  constructor(data?: IPasswordChangeRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.username = _data["username"];
      this.email = _data["email"];
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
      this.passwordConfirmation = _data["passwordConfirmation"];
    }
  }

  static fromJS(data: any): PasswordChangeRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new PasswordChangeRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["username"] = this.username;
    data["email"] = this.email;
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    data["passwordConfirmation"] = this.passwordConfirmation;
    return data;
  }
}

export interface IPasswordChangeRequestDto {
  username: string | undefined;
  email: string | undefined;
  currentPassword: string;
  newPassword: string;
  passwordConfirmation: string;

  [key: string]: any;
}

export type PetBehavior = "Unknown" | "PerfectlySafe" | "LowDanger" | "MediumDanger" | "HighDanger";

export class PetDto implements IPetDto {
  id!: string;
  chipNumber!: string;
  nickname!: string;
  neuteringStatus!: NeuteringStatus;
  gender!: Gender;
  anamnesis!: string;
  dateOfBirth!: DateTime;
  color!: string;
  species!: Species;
  race!: string;
  behavior!: PetBehavior;
  behaviorText!: string;
  ownerId!: string;
  treatmentIds!: string[];
  skeletonAnnotationId!: string;
  isInsured!: boolean;
  insuranceProvider!: string;
  insuranceNumber!: string;
  hasHomeVet!: boolean;
  homeVet!: VeterinarianDto | undefined;
  firstTreatmentDate!: DateTime;
  hasBreederGivenName!: boolean;
  breederGivenName!: string;
  skeletonAnnotation!: ImageAnnotation | undefined;

  [key: string]: any;

  constructor(data?: IPetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.chipNumber = _data["chipNumber"];
      this.nickname = _data["nickname"];
      this.neuteringStatus = _data["neuteringStatus"];
      this.gender = _data["gender"];
      this.anamnesis = _data["anamnesis"];
      this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : undefined as any;
      this.color = _data["color"];
      this.species = _data["species"];
      this.race = _data["race"];
      this.behavior = _data["behavior"];
      this.behaviorText = _data["behaviorText"];
      this.ownerId = _data["ownerId"];
      if (Array.isArray(_data["treatmentIds"])) {
        this.treatmentIds = [] as any;
        for (let item of _data["treatmentIds"])
          this.treatmentIds!.push(item);
      }
      this.skeletonAnnotationId = _data["skeletonAnnotationId"];
      this.isInsured = _data["isInsured"];
      this.insuranceProvider = _data["insuranceProvider"];
      this.insuranceNumber = _data["insuranceNumber"];
      this.hasHomeVet = _data["hasHomeVet"];
      this.homeVet = _data["homeVet"] ? VeterinarianDto.fromJS(_data["homeVet"]) : undefined as any;
      this.firstTreatmentDate = _data["firstTreatmentDate"] ? DateTime.fromISO(_data["firstTreatmentDate"].toString()) : undefined as any;
      this.hasBreederGivenName = _data["hasBreederGivenName"];
      this.breederGivenName = _data["breederGivenName"];
      this.skeletonAnnotation = _data["skeletonAnnotation"] ? ImageAnnotation.fromJS(_data["skeletonAnnotation"]) : undefined as any;
    }
  }

  static fromJS(data: any): PetDto {
    data = typeof data === 'object' ? data : {};
    let result = new PetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["chipNumber"] = this.chipNumber;
    data["nickname"] = this.nickname;
    data["neuteringStatus"] = this.neuteringStatus;
    data["gender"] = this.gender;
    data["anamnesis"] = this.anamnesis;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : undefined as any;
    data["color"] = this.color;
    data["species"] = this.species;
    data["race"] = this.race;
    data["behavior"] = this.behavior;
    data["behaviorText"] = this.behaviorText;
    data["ownerId"] = this.ownerId;
    if (Array.isArray(this.treatmentIds)) {
      data["treatmentIds"] = [];
      for (let item of this.treatmentIds)
        data["treatmentIds"].push(item);
    }
    data["skeletonAnnotationId"] = this.skeletonAnnotationId;
    data["isInsured"] = this.isInsured;
    data["insuranceProvider"] = this.insuranceProvider;
    data["insuranceNumber"] = this.insuranceNumber;
    data["hasHomeVet"] = this.hasHomeVet;
    data["homeVet"] = this.homeVet ? this.homeVet.toJSON() : undefined as any;
    data["firstTreatmentDate"] = this.firstTreatmentDate ? this.firstTreatmentDate.toString() : undefined as any;
    data["hasBreederGivenName"] = this.hasBreederGivenName;
    data["breederGivenName"] = this.breederGivenName;
    data["skeletonAnnotation"] = this.skeletonAnnotation ? this.skeletonAnnotation.toJSON() : undefined as any;
    return data;
  }
}

export interface IPetDto {
  id: string;
  chipNumber: string;
  nickname: string;
  neuteringStatus: NeuteringStatus;
  gender: Gender;
  anamnesis: string;
  dateOfBirth: DateTime;
  color: string;
  species: Species;
  race: string;
  behavior: PetBehavior;
  behaviorText: string;
  ownerId: string;
  treatmentIds: string[];
  skeletonAnnotationId: string;
  isInsured: boolean;
  insuranceProvider: string;
  insuranceNumber: string;
  hasHomeVet: boolean;
  homeVet: VeterinarianDto | undefined;
  firstTreatmentDate: DateTime;
  hasBreederGivenName: boolean;
  breederGivenName: string;
  skeletonAnnotation: ImageAnnotation | undefined;

  [key: string]: any;
}

export class ProblemDetails implements IProblemDetails {
  type!: string | undefined;
  title!: string | undefined;
  status!: number | undefined;
  detail!: string | undefined;
  instance!: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;

  [key: string]: any;
}

export class RefreshTokenRequestDto implements IRefreshTokenRequestDto {
  refreshToken!: string;

  [key: string]: any;

  constructor(data?: IRefreshTokenRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.refreshToken = _data["refreshToken"];
    }
  }

  static fromJS(data: any): RefreshTokenRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new RefreshTokenRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["refreshToken"] = this.refreshToken;
    return data;
  }
}

export interface IRefreshTokenRequestDto {
  refreshToken: string;

  [key: string]: any;
}

export class RegisterRequestDto implements IRegisterRequestDto {
  email!: string;
  password!: string;
  username!: string;
  firstName!: string;
  lastName!: string;
  tenantId!: string;

  [key: string]: any;

  constructor(data?: IRegisterRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.email = _data["email"];
      this.password = _data["password"];
      this.username = _data["username"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.tenantId = _data["tenantId"];
    }
  }

  static fromJS(data: any): RegisterRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["email"] = this.email;
    data["password"] = this.password;
    data["username"] = this.username;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["tenantId"] = this.tenantId;
    return data;
  }
}

export interface IRegisterRequestDto {
  email: string;
  password: string;
  username: string;
  firstName: string;
  lastName: string;
  tenantId: string;

  [key: string]: any;
}

export class SetPasswordRequestDto implements ISetPasswordRequestDto {
  userName!: string;
  resetPasswordToken!: string;
  password!: string;
  language!: string;

  [key: string]: any;

  constructor(data?: ISetPasswordRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.userName = _data["userName"];
      this.resetPasswordToken = _data["resetPasswordToken"];
      this.password = _data["password"];
      this.language = _data["language"];
    }
  }

  static fromJS(data: any): SetPasswordRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new SetPasswordRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["userName"] = this.userName;
    data["resetPasswordToken"] = this.resetPasswordToken;
    data["password"] = this.password;
    data["language"] = this.language;
    return data;
  }
}

export interface ISetPasswordRequestDto {
  userName: string;
  resetPasswordToken: string;
  password: string;
  language: string;

  [key: string]: any;
}

export type Species = "Dog" | "Cat";

export class TenantDto implements ITenantDto {
  id!: string;
  name!: string;
  contactName!: string;
  contactPhone!: string;
  customerIds!: string[];
  treatmentIds!: string[];
  street!: string;
  houseNumber!: string;
  postalCode!: string;
  city!: string;
  country!: string;
  createdAt!: DateTime;
  createdBy!: string;
  modifiedAt!: DateTime | undefined;
  modifiedBy!: string | undefined;
  markedAsDeletable!: boolean;
  deletedAt!: DateTime | undefined;
  deletedBy!: string | undefined;

  [key: string]: any;

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.name = _data["name"];
      this.contactName = _data["contactName"];
      this.contactPhone = _data["contactPhone"];
      if (Array.isArray(_data["customerIds"])) {
        this.customerIds = [] as any;
        for (let item of _data["customerIds"])
          this.customerIds!.push(item);
      }
      if (Array.isArray(_data["treatmentIds"])) {
        this.treatmentIds = [] as any;
        for (let item of _data["treatmentIds"])
          this.treatmentIds!.push(item);
      }
      this.street = _data["street"];
      this.houseNumber = _data["houseNumber"];
      this.postalCode = _data["postalCode"];
      this.city = _data["city"];
      this.country = _data["country"];
      this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
      this.createdBy = _data["createdBy"];
      this.modifiedAt = _data["modifiedAt"] ? DateTime.fromISO(_data["modifiedAt"].toString()) : undefined as any;
      this.modifiedBy = _data["modifiedBy"];
      this.markedAsDeletable = _data["markedAsDeletable"];
      this.deletedAt = _data["deletedAt"] ? DateTime.fromISO(_data["deletedAt"].toString()) : undefined as any;
      this.deletedBy = _data["deletedBy"];
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["name"] = this.name;
    data["contactName"] = this.contactName;
    data["contactPhone"] = this.contactPhone;
    if (Array.isArray(this.customerIds)) {
      data["customerIds"] = [];
      for (let item of this.customerIds)
        data["customerIds"].push(item);
    }
    if (Array.isArray(this.treatmentIds)) {
      data["treatmentIds"] = [];
      for (let item of this.treatmentIds)
        data["treatmentIds"].push(item);
    }
    data["street"] = this.street;
    data["houseNumber"] = this.houseNumber;
    data["postalCode"] = this.postalCode;
    data["city"] = this.city;
    data["country"] = this.country;
    data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
    data["createdBy"] = this.createdBy;
    data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toString() : undefined as any;
    data["modifiedBy"] = this.modifiedBy;
    data["markedAsDeletable"] = this.markedAsDeletable;
    data["deletedAt"] = this.deletedAt ? this.deletedAt.toString() : undefined as any;
    data["deletedBy"] = this.deletedBy;
    return data;
  }
}

export interface ITenantDto {
  id: string;
  name: string;
  contactName: string;
  contactPhone: string;
  customerIds: string[];
  treatmentIds: string[];
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;
  createdAt: DateTime;
  createdBy: string;
  modifiedAt: DateTime | undefined;
  modifiedBy: string | undefined;
  markedAsDeletable: boolean;
  deletedAt: DateTime | undefined;
  deletedBy: string | undefined;

  [key: string]: any;
}

export class TreatmentDto implements ITreatmentDto {
  id!: string;
  title!: string;
  description!: string;
  appointmentDate!: DateTime;
  patientId!: string;
  tenantId!: string;
  customerId!: string;

  [key: string]: any;

  constructor(data?: ITreatmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.title = _data["title"];
      this.description = _data["description"];
      this.appointmentDate = _data["appointmentDate"] ? DateTime.fromISO(_data["appointmentDate"].toString()) : undefined as any;
      this.patientId = _data["patientId"];
      this.tenantId = _data["tenantId"];
      this.customerId = _data["customerId"];
    }
  }

  static fromJS(data: any): TreatmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new TreatmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["title"] = this.title;
    data["description"] = this.description;
    data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toString() : undefined as any;
    data["patientId"] = this.patientId;
    data["tenantId"] = this.tenantId;
    data["customerId"] = this.customerId;
    return data;
  }
}

export interface ITreatmentDto {
  id: string;
  title: string;
  description: string;
  appointmentDate: DateTime;
  patientId: string;
  tenantId: string;
  customerId: string;

  [key: string]: any;
}

export class TreatmentShortInfoDto implements ITreatmentShortInfoDto {
  id!: string;
  title!: string;
  appointmentDate!: DateTime;
  ownerId!: string;
  ownerFirstName!: string;
  ownerLastName!: string;
  patientId!: string;
  patientName!: string;

  [key: string]: any;

  constructor(data?: ITreatmentShortInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.title = _data["title"];
      this.appointmentDate = _data["appointmentDate"] ? DateTime.fromISO(_data["appointmentDate"].toString()) : undefined as any;
      this.ownerId = _data["ownerId"];
      this.ownerFirstName = _data["ownerFirstName"];
      this.ownerLastName = _data["ownerLastName"];
      this.patientId = _data["patientId"];
      this.patientName = _data["patientName"];
    }
  }

  static fromJS(data: any): TreatmentShortInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new TreatmentShortInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["title"] = this.title;
    data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toString() : undefined as any;
    data["ownerId"] = this.ownerId;
    data["ownerFirstName"] = this.ownerFirstName;
    data["ownerLastName"] = this.ownerLastName;
    data["patientId"] = this.patientId;
    data["patientName"] = this.patientName;
    return data;
  }
}

export interface ITreatmentShortInfoDto {
  id: string;
  title: string;
  appointmentDate: DateTime;
  ownerId: string;
  ownerFirstName: string;
  ownerLastName: string;
  patientId: string;
  patientName: string;

  [key: string]: any;
}

export class TupleOfintAndint implements ITupleOfintAndint {
  x!: number;
  y!: number;

  [key: string]: any;

  constructor(data?: ITupleOfintAndint) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.x = _data["x"];
      this.y = _data["y"];
    }
  }

  static fromJS(data: any): TupleOfintAndint {
    data = typeof data === 'object' ? data : {};
    let result = new TupleOfintAndint();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["x"] = this.x;
    data["y"] = this.y;
    return data;
  }
}

export interface ITupleOfintAndint {
  x: number;
  y: number;

  [key: string]: any;
}

export class TupleOfstringAndstring implements ITupleOfstringAndstring {
  x!: string | undefined;
  y!: string | undefined;

  [key: string]: any;

  constructor(data?: ITupleOfstringAndstring) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.x = _data["x"];
      this.y = _data["y"];
    }
  }

  static fromJS(data: any): TupleOfstringAndstring {
    data = typeof data === 'object' ? data : {};
    let result = new TupleOfstringAndstring();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["x"] = this.x;
    data["y"] = this.y;
    return data;
  }
}

export interface ITupleOfstringAndstring {
  x: string | undefined;
  y: string | undefined;

  [key: string]: any;
}

export class UpdateCustomerRequestDto implements IUpdateCustomerRequestDto {
  id!: string;
  firstName!: string;
  lastName!: string;
  company!: string;
  eMail!: string;
  phoneNumber!: string;
  street!: string;
  houseNumber!: string;
  postalCode!: string;
  city!: string;
  country!: string;
  notes!: string;

  [key: string]: any;

  constructor(data?: IUpdateCustomerRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.company = _data["company"];
      this.eMail = _data["eMail"];
      this.phoneNumber = _data["phoneNumber"];
      this.street = _data["street"];
      this.houseNumber = _data["houseNumber"];
      this.postalCode = _data["postalCode"];
      this.city = _data["city"];
      this.country = _data["country"];
      this.notes = _data["notes"];
    }
  }

  static fromJS(data: any): UpdateCustomerRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateCustomerRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["company"] = this.company;
    data["eMail"] = this.eMail;
    data["phoneNumber"] = this.phoneNumber;
    data["street"] = this.street;
    data["houseNumber"] = this.houseNumber;
    data["postalCode"] = this.postalCode;
    data["city"] = this.city;
    data["country"] = this.country;
    data["notes"] = this.notes;
    return data;
  }
}

export interface IUpdateCustomerRequestDto {
  id: string;
  firstName: string;
  lastName: string;
  company: string;
  eMail: string;
  phoneNumber: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;
  notes: string;

  [key: string]: any;
}

export class UpdatePetRequestDto implements IUpdatePetRequestDto {
  id!: string;
  chipNumber!: string;
  nickname!: string;
  hasBreederGivenName!: boolean;
  breederGivenName!: string | undefined;
  anamnesis!: string;
  dateOfBirth!: DateTime;
  color!: string;
  race!: string;
  behavior!: PetBehavior;
  behaviorText!: string;
  ownerId!: string;
  species!: Species;
  neuteringStatus!: NeuteringStatus;
  gender!: Gender;
  isInsured!: boolean;
  insuranceProvider!: string | undefined;
  insuranceNumber!: string | undefined;
  hasHomeVet!: boolean;
  homeVet!: Veterinarian | undefined;
  firstTreatmentDate!: DateTime;

  [key: string]: any;

  constructor(data?: IUpdatePetRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.chipNumber = _data["chipNumber"];
      this.nickname = _data["nickname"];
      this.hasBreederGivenName = _data["hasBreederGivenName"];
      this.breederGivenName = _data["breederGivenName"];
      this.anamnesis = _data["anamnesis"];
      this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : undefined as any;
      this.color = _data["color"];
      this.race = _data["race"];
      this.behavior = _data["behavior"];
      this.behaviorText = _data["behaviorText"];
      this.ownerId = _data["ownerId"];
      this.species = _data["species"];
      this.neuteringStatus = _data["neuteringStatus"];
      this.gender = _data["gender"];
      this.isInsured = _data["isInsured"];
      this.insuranceProvider = _data["insuranceProvider"];
      this.insuranceNumber = _data["insuranceNumber"];
      this.hasHomeVet = _data["hasHomeVet"];
      this.homeVet = _data["homeVet"] ? Veterinarian.fromJS(_data["homeVet"]) : undefined as any;
      this.firstTreatmentDate = _data["firstTreatmentDate"] ? DateTime.fromISO(_data["firstTreatmentDate"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): UpdatePetRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdatePetRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["chipNumber"] = this.chipNumber;
    data["nickname"] = this.nickname;
    data["hasBreederGivenName"] = this.hasBreederGivenName;
    data["breederGivenName"] = this.breederGivenName;
    data["anamnesis"] = this.anamnesis;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : undefined as any;
    data["color"] = this.color;
    data["race"] = this.race;
    data["behavior"] = this.behavior;
    data["behaviorText"] = this.behaviorText;
    data["ownerId"] = this.ownerId;
    data["species"] = this.species;
    data["neuteringStatus"] = this.neuteringStatus;
    data["gender"] = this.gender;
    data["isInsured"] = this.isInsured;
    data["insuranceProvider"] = this.insuranceProvider;
    data["insuranceNumber"] = this.insuranceNumber;
    data["hasHomeVet"] = this.hasHomeVet;
    data["homeVet"] = this.homeVet ? this.homeVet.toJSON() : undefined as any;
    data["firstTreatmentDate"] = this.firstTreatmentDate ? this.firstTreatmentDate.toString() : undefined as any;
    return data;
  }
}

export interface IUpdatePetRequestDto {
  id: string;
  chipNumber: string;
  nickname: string;
  hasBreederGivenName: boolean;
  breederGivenName: string | undefined;
  anamnesis: string;
  dateOfBirth: DateTime;
  color: string;
  race: string;
  behavior: PetBehavior;
  behaviorText: string;
  ownerId: string;
  species: Species;
  neuteringStatus: NeuteringStatus;
  gender: Gender;
  isInsured: boolean;
  insuranceProvider: string | undefined;
  insuranceNumber: string | undefined;
  hasHomeVet: boolean;
  homeVet: Veterinarian | undefined;
  firstTreatmentDate: DateTime;

  [key: string]: any;
}

export class UpdateTenantRequestDto implements IUpdateTenantRequestDto {
  id!: string;
  name!: string;
  contactName!: string;
  contactPhone!: string;
  street!: string;
  houseNumber!: string;
  postalCode!: string;
  city!: string;
  country!: string;

  [key: string]: any;

  constructor(data?: IUpdateTenantRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.name = _data["name"];
      this.contactName = _data["contactName"];
      this.contactPhone = _data["contactPhone"];
      this.street = _data["street"];
      this.houseNumber = _data["houseNumber"];
      this.postalCode = _data["postalCode"];
      this.city = _data["city"];
      this.country = _data["country"];
    }
  }

  static fromJS(data: any): UpdateTenantRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTenantRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["name"] = this.name;
    data["contactName"] = this.contactName;
    data["contactPhone"] = this.contactPhone;
    data["street"] = this.street;
    data["houseNumber"] = this.houseNumber;
    data["postalCode"] = this.postalCode;
    data["city"] = this.city;
    data["country"] = this.country;
    return data;
  }
}

export interface IUpdateTenantRequestDto {
  id: string;
  name: string;
  contactName: string;
  contactPhone: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;

  [key: string]: any;
}

export class UpdateTreatmentRequestDto implements IUpdateTreatmentRequestDto {
  id!: string;
  description!: string;
  appointmentDate!: DateTime;
  title!: string;

  [key: string]: any;

  constructor(data?: IUpdateTreatmentRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.description = _data["description"];
      this.appointmentDate = _data["appointmentDate"] ? DateTime.fromISO(_data["appointmentDate"].toString()) : undefined as any;
      this.title = _data["title"];
    }
  }

  static fromJS(data: any): UpdateTreatmentRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTreatmentRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["description"] = this.description;
    data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toString() : undefined as any;
    data["title"] = this.title;
    return data;
  }
}

export interface IUpdateTreatmentRequestDto {
  id: string;
  description: string;
  appointmentDate: DateTime;
  title: string;

  [key: string]: any;
}

export class UserCheckRequestDto implements IUserCheckRequestDto {
  username!: string;

  [key: string]: any;

  constructor(data?: IUserCheckRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.username = _data["username"];
    }
  }

  static fromJS(data: any): UserCheckRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserCheckRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["username"] = this.username;
    return data;
  }
}

export interface IUserCheckRequestDto {
  username: string;

  [key: string]: any;
}

export class UserCheckResponseDto implements IUserCheckResponseDto {
  resetToken!: string;
  firstLogin!: boolean;
  userRole!: string;

  [key: string]: any;

  constructor(data?: IUserCheckResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.resetToken = _data["resetToken"];
      this.firstLogin = _data["firstLogin"];
      this.userRole = _data["userRole"];
    }
  }

  static fromJS(data: any): UserCheckResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserCheckResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["resetToken"] = this.resetToken;
    data["firstLogin"] = this.firstLogin;
    data["userRole"] = this.userRole;
    return data;
  }
}

export interface IUserCheckResponseDto {
  resetToken: string;
  firstLogin: boolean;
  userRole: string;

  [key: string]: any;
}

export class UserDto implements IUserDto {
  id!: string;
  userName!: string;
  email!: string;
  emailConfirmed!: boolean;
  twoFactorEnabled!: boolean;
  accessFailedCount!: number;
  lockoutEnabled!: boolean;
  tenantId!: string;
  firstName!: string;
  lastName!: string;
  passwordChangeRequested!: boolean;
  isFirstLogin!: boolean;
  language!: number | undefined;
  createdAt!: DateTime;
  createdBy!: string;
  modifiedAt!: DateTime | undefined;
  modifiedBy!: string | undefined;
  markedAsDeletable!: boolean;
  deletedAt!: DateTime | undefined;
  deletedBy!: string | undefined;

  [key: string]: any;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.id = _data["id"];
      this.userName = _data["userName"];
      this.email = _data["email"];
      this.emailConfirmed = _data["emailConfirmed"];
      this.twoFactorEnabled = _data["twoFactorEnabled"];
      this.accessFailedCount = _data["accessFailedCount"];
      this.lockoutEnabled = _data["lockoutEnabled"];
      this.tenantId = _data["tenantId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.passwordChangeRequested = _data["passwordChangeRequested"];
      this.isFirstLogin = _data["isFirstLogin"];
      this.language = _data["language"];
      this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
      this.createdBy = _data["createdBy"];
      this.modifiedAt = _data["modifiedAt"] ? DateTime.fromISO(_data["modifiedAt"].toString()) : undefined as any;
      this.modifiedBy = _data["modifiedBy"];
      this.markedAsDeletable = _data["markedAsDeletable"];
      this.deletedAt = _data["deletedAt"] ? DateTime.fromISO(_data["deletedAt"].toString()) : undefined as any;
      this.deletedBy = _data["deletedBy"];
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["id"] = this.id;
    data["userName"] = this.userName;
    data["email"] = this.email;
    data["emailConfirmed"] = this.emailConfirmed;
    data["twoFactorEnabled"] = this.twoFactorEnabled;
    data["accessFailedCount"] = this.accessFailedCount;
    data["lockoutEnabled"] = this.lockoutEnabled;
    data["tenantId"] = this.tenantId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["passwordChangeRequested"] = this.passwordChangeRequested;
    data["isFirstLogin"] = this.isFirstLogin;
    data["language"] = this.language;
    data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
    data["createdBy"] = this.createdBy;
    data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toString() : undefined as any;
    data["modifiedBy"] = this.modifiedBy;
    data["markedAsDeletable"] = this.markedAsDeletable;
    data["deletedAt"] = this.deletedAt ? this.deletedAt.toString() : undefined as any;
    data["deletedBy"] = this.deletedBy;
    return data;
  }
}

export interface IUserDto {
  id: string;
  userName: string;
  email: string;
  emailConfirmed: boolean;
  twoFactorEnabled: boolean;
  accessFailedCount: number;
  lockoutEnabled: boolean;
  tenantId: string;
  firstName: string;
  lastName: string;
  passwordChangeRequested: boolean;
  isFirstLogin: boolean;
  language: number | undefined;
  createdAt: DateTime;
  createdBy: string;
  modifiedAt: DateTime | undefined;
  modifiedBy: string | undefined;
  markedAsDeletable: boolean;
  deletedAt: DateTime | undefined;
  deletedBy: string | undefined;

  [key: string]: any;
}

export class Veterinarian implements IVeterinarian {
  name!: string;
  phoneNumber!: string;

  [key: string]: any;

  constructor(data?: IVeterinarian) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.name = _data["name"];
      this.phoneNumber = _data["phoneNumber"];
    }
  }

  static fromJS(data: any): Veterinarian {
    data = typeof data === 'object' ? data : {};
    let result = new Veterinarian();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["name"] = this.name;
    data["phoneNumber"] = this.phoneNumber;
    return data;
  }
}

export interface IVeterinarian {
  name: string;
  phoneNumber: string;

  [key: string]: any;
}

export class VeterinarianDto implements IVeterinarianDto {
  name!: string;
  phoneNumber!: string;

  [key: string]: any;

  constructor(data?: IVeterinarianDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.name = _data["name"];
      this.phoneNumber = _data["phoneNumber"];
    }
  }

  static fromJS(data: any): VeterinarianDto {
    data = typeof data === 'object' ? data : {};
    let result = new VeterinarianDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["name"] = this.name;
    data["phoneNumber"] = this.phoneNumber;
    return data;
  }
}

export interface IVeterinarianDto {
  name: string;
  phoneNumber: string;

  [key: string]: any;
}

export class SwaggerResponse<TResult> {
  status: number;
  headers: { [key: string]: any; };
  result: TResult;

  constructor(status: number, headers: { [key: string]: any; }, result: TResult)
  {
    this.status = status;
    this.headers = headers;
    this.result = result;
  }
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
